export default "__VITE_PUBLIC_ASSET__7c2afd15__"